<template>
  <div class="app-container">
    <el-tabs v-model="doctype" @tab-click="handleClick">
      <el-tab-pane label="自制领料任务" name="自制领料任务"></el-tab-pane>
      <el-tab-pane label="自制入库任务" name="自制入库任务"></el-tab-pane>
      <el-tab-pane label="采购入库任务" name="采购入库任务"></el-tab-pane>
      <el-tab-pane label="委外领料任务" name="委外领料任务"></el-tab-pane>
      <el-tab-pane label="委外入库任务" name="委外入库任务"></el-tab-pane>
      <el-tab-pane label="销售发货任务" name="销售发货任务"></el-tab-pane>
    </el-tabs>

    <el-radio-group v-model="TaskType">
      <el-radio label="发给部门">发给部门</el-radio>
      <el-radio label="发给加工单元">发给加工单元</el-radio>
      <el-radio label="发给人员">发给人员</el-radio>
    </el-radio-group>
    <div style="margin: 10px 0">
      <el-button type="primary" @click="openEmpDialog(true)" v-if="TaskType == '发给人员'">添加</el-button>
    </div>
    <el-table :data="tableData.filter((item) => item.T != 2)" style="width: 600px" v-if="TaskType == '发给人员'">
      <el-table-column prop="DpName" label="部门"></el-table-column>
      <el-table-column prop="WarehouseId" label="仓库">
        <template slot-scope="{ row }">
          <el-select v-model="row.WarehouseId" @change="editT(row)" clearable>
            <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="EmpId" label="用户">
        <template slot-scope="{ row, $index }">
          <select-input placeholder="选择用户" :label="row.EmpName" v-model="row.EmpId" @click="openEmpDialog(false, $index)" />
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作">
        <template slot-scope="{ row }">
          <el-button type="text" size="small" @click="onDel(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin: 10px 0">
      <el-button type="primary" @click="onSave">保存</el-button>
    </div>

    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
  </div>
</template>
<script>
import curdMixins from '@/mixins/trend/curd'
import empDialog from '@/components/personnel/result/record/listDialog'

export default {
  name: 'pdatask',
  mixins: [curdMixins],
  components: { empDialog },
  data() {
    return {
      api: require('@/api/sy/task').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      doctype: '自制领料任务',
      TaskId: 0,
      TaskType: '发给部门',
      tableData: [],
      warehouseList: [],
      tableIndex: null,
      isAddEmp: true
    }
  },
  created() {
    this.getDocTypeInfo()
    this.warehouseApi.list({}).then(res => {
      if (res.Code === 0) {
        this.warehouseList = res.Data
      }
    })
  },
  activated(){
    this.getDocTypeInfo()
  },
  methods: {
    getDocTypeInfo() {
      this.api.docTypeInfo({ doctype: this.doctype }).then(res => {
        if (res.Code == 0) {
          this.TaskId = res.Data.TaskId
          this.TaskType = res.Data.TaskType
          this.tableData = res.Data.DtsModels.map(item => {
            return {
              ...item,
              T: null
            }
          })
        } else {
          this.TaskId = 0
        }
      })
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1
      }
    },
    openEmpDialog(isAddEmp, index) {
      this.tableIndex = index
      this.isAddEmp = isAddEmp
      this.$refs.empDialog.open().then(that => {
        that.getData()
      })
    },
    setEmp(emp) {
      if (this.isAddEmp) {
        this.tableData.push({
          T: 0,
          DpName: emp.DpName,
          EmpId: emp.EmpId,
          EmpName: emp.EmpName
        })
      } else {
        this.tableData[this.tableIndex].T = this.tableData[this.tableIndex].T == 0 ? 0 : 1
        this.tableData[this.tableIndex].EmpId = emp.EmpId ?? null
        this.tableData[this.tableIndex].EmpName = emp.EmpName ?? null
        this.tableData[this.tableIndex].DpName = emp.DpName ?? null
      }
    },
    onDel(row) {
      if (row.T == 0) {
        this.tableData = this.tableData.filter(item => item != row)
      } else {
        if (row.T != 0) row.T = 2
      }
    },
    handleClick() {
      this.TaskId = 0
      this.TaskType = null
      this.tableData = []
      this.getDocTypeInfo()
    },
    onSave() {
      const o = {
        TaskId: this.TaskId,
        doctype: this.doctype,
        TaskType: this.TaskType,
        DtsModels: this.tableData ? this.tableData.filter(item => item.T != null) : []
      }
      this.api.save(o).then(res => {
        if (res.Code == 0) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(res.Msg)
        }
      })
    }
  }
}
</script>
